module.exports = __webpack_public_path__ + "static/media/solutionimg.23a5e7e8.png";